import CartableTree from '../cartabletree/cartableTree.vue';
export default {
    data() {
        return {
            userTitle: '',
            userStaff: '',
            staffTooltip: [],
            hasAvatar: payload.hasAvatar
        }
    },
    computed: {
        customerLogo () {
            return payload.customerLogo
        },
        logoUrl () {
            let url = 'http://bpms.rayvarz.com'
            if (payload.customerLogo === 'dist/interfacing_logo.png')
                url = 'https://interfacing.com'
            return this.customerLogo === 'handlers/applicationfilehandler.ashx?action=customerlogo' ? '#' : url
        },
        hasBanner () {
            return payload.hasBanner
        }
    },
    mounted() {

        $(window).on('scroll', () => {
            this.rePosition()
        })

        $(window).on('resize', () => {
            this.rePosition()
        })

        this.rePosition()

        this.userTitle = payload.CurrentUser.Title;
        if (payload.CurrentUser.Staffs !== null && payload.CurrentUser.Staffs.length > 0) {

            if (payload.CurrentUser.Staffs.length === 1) {
                this.userStaff = payload.CurrentUser.Staffs[0].Title;
            }
            // else {
            //     this.userStaff = this.$t('view_all_staff');
            // }
        }
    },
    methods: {
        rePosition() {
            if (!this.hasBanner) {
                $(this.$el).css('top', '0px');
                return;
            }

            if (window.pageYOffset > 149) {
                $(this.$el).css('top', '0px');
            } else {
                if (window.pageYOffset < 149) {
                    $(this.$el).css('top',149- window.pageYOffset+'px');
                }
                else
                $(this.$el).css('top', '149px');
        }

      }
    },
    components: {
        CartableTree
    }
}
